/*
  PulloraX - image hover zoom helper, magazine lightbox, download deterrent.
  The lightbox runs only on magazine / blog / article templates (data-template on the script tag).
*/
(function () {
  'use strict';

  var script = document.currentScript;
  var template = ((script && script.dataset.template) || '').toLowerCase();
  var lightboxOn = /magazine|article|blog/.test(template);

  /* ---------- 3. Download deterrent ---------- */
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if ((t && t.tagName === 'IMG') || (t && t.closest && t.closest('.px-lb'))) e.preventDefault();
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  }, true);

  /* ---------- 1. Hover zoom: skip icons and tiny images ---------- */
  function markSmall() {
    var imgs = document.querySelectorAll('#MainContent img');
    for (var i = 0; i < imgs.length; i++) {
      var w = imgs[i].getBoundingClientRect().width;
      if (w && w < 80) imgs[i].classList.add('px-nozoom');
    }
  }
  window.addEventListener('load', markSmall);

  if (!lightboxOn) return;

  /* ---------- 2. Lightbox ---------- */
  var main = document.getElementById('MainContent');
  if (!main) return;

  var rtl = document.documentElement.getAttribute('dir') === 'rtl';
  var he = (document.documentElement.lang || '').toLowerCase().indexOf('he') === 0;
  var L = he
    ? { close: '\u05e1\u05d2\u05d9\u05e8\u05d4', prev: '\u05ea\u05de\u05d5\u05e0\u05d4 \u05e7\u05d5\u05d3\u05de\u05ea', next: '\u05ea\u05de\u05d5\u05e0\u05d4 \u05d4\u05d1\u05d0\u05d4', dialog: '\u05ea\u05de\u05d5\u05e0\u05d4 \u05de\u05d5\u05d2\u05d3\u05dc\u05ea' }
    : { close: 'Close', prev: 'Previous image', next: 'Next image', dialog: 'Enlarged image' };

  if ((document.documentElement.lang || '').toLowerCase().slice(0, 2) === 'it') L = { close: 'Chiudi', prev: 'Immagine precedente', next: 'Immagine successiva', dialog: 'Immagine ingrandita' };

  function eligible(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.closest('a, button')) return false; // linked images keep navigating
    return img.getBoundingClientRect().width >= 120;
  }

  function bestSrc(img) {
    var ss = img.getAttribute('srcset');
    if (ss) {
      var best = null, bw = 0;
      ss.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var w = parseInt(bits[1], 10) || 0;
        if (bits[0] && w >= bw) { bw = w; best = bits[0]; }
      });
      if (best) return best;
    }
    return (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000');
  }

  var box, bigImg, btnClose, btnPrev, btnNext, counter, gallery = [], index = 0, lastFocus = null, touchX = null;

  function build() {
    box = document.createElement('div');
    box.className = 'px-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', L.dialog);

    bigImg = document.createElement('img');
    bigImg.className = 'px-lb__img';
    bigImg.setAttribute('draggable', 'false');
    bigImg.alt = '';

    btnClose = makeBtn('px-lb__close', L.close, '\u00d7');
    btnPrev = makeBtn('px-lb__prev', L.prev, rtl ? '\u203a' : '\u2039');
    btnNext = makeBtn('px-lb__next', L.next, rtl ? '\u2039' : '\u203a');

    counter = document.createElement('div');
    counter.className = 'px-lb__count';
    counter.setAttribute('aria-live', 'polite');

    box.appendChild(bigImg);
    box.appendChild(btnPrev);
    box.appendChild(btnNext);
    box.appendChild(btnClose);
    box.appendChild(counter);
    document.body.appendChild(box);

    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target === bigImg) close(); });
    box.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 50) return;
      var forward = dx < 0;
      if (rtl) forward = !forward;
      go(forward ? 1 : -1);
    });
  }

  function makeBtn(cls, label, glyph) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'px-lb__btn ' + cls;
    b.setAttribute('aria-label', label);
    b.textContent = glyph;
    return b;
  }

  function show() {
    var img = gallery[index];
    bigImg.src = bestSrc(img);
    bigImg.alt = img.alt || '';
    var many = gallery.length > 1;
    btnPrev.hidden = !many;
    btnNext.hidden = !many;
    counter.textContent = many ? (index + 1) + ' / ' + gallery.length : '';
  }

  function go(step) {
    if (gallery.length < 2) return;
    index = (index + step + gallery.length) % gallery.length;
    show();
  }

  function open(img) {
    if (!box) build();
    gallery = Array.prototype.filter.call(main.querySelectorAll('img'), eligible);
    index = Math.max(0, gallery.indexOf(img));
    lastFocus = document.activeElement;
    show();
    document.documentElement.classList.add('px-lb-lock');
    box.classList.add('is-open');
    btnClose.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    box.classList.remove('is-open');
    document.documentElement.classList.remove('px-lb-lock');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowRight') go(rtl ? -1 : 1);
    if (e.key === 'ArrowLeft') go(rtl ? 1 : -1);
    if (e.key === 'Tab') {
      var f = [btnPrev, btnNext, btnClose].filter(function (b) { return !b.hidden; });
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      var n = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i + 1) % f.length;
      f[n].focus();
    }
  }

  main.addEventListener('mouseover', function (e) {
    if (eligible(e.target)) e.target.classList.add('px-lb-able');
  });
  main.addEventListener('click', function (e) {
    if (eligible(e.target)) { e.preventDefault(); open(e.target); }
  });
})();
